import React, { useState } from 'react';
import InterviewModal from './CreateInterviewModal';

const AddInterviewButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <button onClick={() => setIsModalOpen(true)} className="btn btn-primary">
        Add New Interview
      </button>

      <InterviewModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default AddInterviewButton;
